var BaseViews = require('../base');

require('./cart-empty/cart-empty.scss');

var CartEmpty = BaseViews.LayoutView.extend({
    className: 'fmcy-cart-empty',
    template: require('./cart-empty/cart-empty.html'),
    initialize: function(options) {
        var self = this;
        this.options = _.defaults(
            options || {},
            {
                _appChannel: null
            }
        );
    },
    serializeData: function () {
      return {
        message: 'Your cart is currently empty'
      }
    },
    ui: {
      cartLeftColumn: '.fmcy-cart-empty-left-column',
      cartRightColumn: '.fmcy-cart-empty-right-column'
    },
    regions: {
        errorMessageRegion: '.fmcy-cart-empty-error-message-region',
        paymentFormRegion: '.fmcy-cart-empty-pay-form-region'
    },
    onRender: function() {
      var self = this;
      $(window).on('resize.' + this.cid, _.bind(this._onWindowResize, this));
      this._onWindowResize();
      BaseViews.LayoutView.prototype.onRender.call(self);
    },
    _onWindowResize: function (event) {
      var magicBuffer = 132;
      var minHeight = $(window).height() - magicBuffer;
      this.$el.css('minHeight', minHeight);
      this.ui.cartLeftColumn.css('minHeight', minHeight);
      this.ui.cartRightColumn.css('minHeight', minHeight);
    },
    onDestroy: function () {
      $(window).off('resize.' + this.cid);
      BaseViews.LayoutView.prototype.onDestroy.call(this);
    }
});

module.exports = CartEmpty;



/** WEBPACK FOOTER **
 ** ./assets/js/common/cart/cart-empty.js
 **/